/**
 * Идентификаторы групп сравнения аудиторий
 */
export enum AudienceCompareGroup {
  audienceX = 'audienceX',
  audienceY = 'audienceY',
  none = 'none',
}
